import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AgentService = {
  getList: async () => {
    const response = await apiService.get("/agents");
    console.log(response);
    return response.data;
  },
  getAvailable: async () => {
    const response = await apiService.get("/agentavailability");
    console.log(response);
    return response.data;
  },

  create: async (data) => {
    const response = await apiService.post("/agents", data);
    return response.data;
  },
  createAvailable: async (data) => {
    const response = await apiService.post("/agentavailability", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    const response = await apiService.put(`/agents/${id}`, updatedData);
    return response.data;
  },
  updateAvailable: async (id, updatedData) => {
    const response = await apiService.put(
      `/agentavailability/${id}`,
      updatedData
    );
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/agents/${id}`);
    console.log("called", response);
    console.log("called", response.data);
    return response.data;
  },
  delete: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/agents/${id}`);
    console.log("called", response);
    return response.data;
  },
  deleteAvailable: async (id) => {
    console.log(id);
    const response = await apiService.delete(`/agentavailability/${id}`);
    console.log("called", response);
    return response.data;
  },
};
export default AgentService;
